<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-06-05 21:37:30
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-06-23 11:19:37
 * @FilePath: \lightning\src\views\warning\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-06-05 21:37:30
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-08-14 11:38:06
 * @FilePath: \lightning\src\views\warning\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="conBody">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="tableHeaderBox">
          <el-button
            type="primary"
            plain
            icon="el-icon-circle-plus-outline"
            @click="isShowAddUserPop=true"
          >新增</el-button>
          <el-button type="primary" plain icon="el-icon-delete">删除</el-button>
          <el-upload
            style="margin-left:15px"
            class="upload-demo"
            action="https://jsonplaceholder.typicode.com/posts/"
            multiple
            :limit="1"
          >
            <el-button type="primary" plain icon="el-icon-upload2">导入</el-button>
          </el-upload>

          <!-- <el-button type="primary" plain>导出</el-button> -->
        </div>
      </div>
      <div>
        <el-table :data="userListData" style="width: 100%" height="650">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="username" label="名称"></el-table-column>
          <el-table-column prop="phonenum" label="手机号码"></el-table-column>
          <el-table-column prop="mail" label="邮箱"></el-table-column>
          <el-table-column prop="other" label="单位"></el-table-column>
          <el-table-column prop="region" label="负责区域"></el-table-column>
          <el-table-column prop="lon" label="经度"></el-table-column>
          <el-table-column prop="lat" label="纬度"></el-table-column>
          <el-table-column prop="ts12" label="12分钟预警">
            <template slot-scope="scope">{{scope.row.ts12==1?"是":"否"}}</template>
          </el-table-column>
          <el-table-column prop="ts30" label="30分钟预警">
            <template slot-scope="scope">{{scope.row.ts30==1?"是":"否"}}</template>
          </el-table-column>
          <el-table-column prop="ts60" label="60分钟预警">
            <template slot-scope="scope">{{scope.row.ts60==1?"是":"否"}}</template>
          </el-table-column>
          <el-table-column prop="autosend" label="自动推送">
            <template slot-scope="scope">{{scope.row.autosend==1?"是":"否"}}</template>
          </el-table-column>
          <!-- <el-table-column prop="re" label="职位"></el-table-column> -->
          <!-- <el-table-column prop="state" label="状态"></el-table-column>
          <el-table-column prop="creater" label="创建者"></el-table-column>
          <el-table-column prop="createTime" label="创建时间"></el-table-column>-->
          <el-table-column prop="lon" label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="warning" size="mini" @click="showEditpopHandell(scope.row)">修改</el-button>
              <el-popconfirm
                style="margin-left:15px"
                title="确定删除吗？"
                @confirm="delUserData(scope.row)"
              >
                <el-button type="warning" size="mini" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <el-dialog
      title="范围查看"
      @opened="openPophandell"
      @closed="closeHandell"
      :visible.sync="isShoMyArea"
      width="80%"
    >
      <div class="digBox" id="newMapBox2">
        <div class="ledgonBox">
          <div class="liColorList">
            <div class="liColorListItem">
              <div class="left" style="background-color:#409EFF"></div>
              <div class="right">无预警</div>
            </div>
            <div class="liColorListItem">
              <div class="left" style="background-color:#e6c700"></div>
              <div class="right">黄色预警</div>
            </div>
            <div class="liColorListItem">
              <div class="left" style="background-color:#e67b00"></div>
              <div class="right">橙色预警</div>
            </div>
            <div class="liColorListItem">
              <div class="left" style="background-color:#e62600"></div>
              <div class="right">红色预警</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="新增人员" :visible.sync="isShowAddUserPop">
      <el-form :model="adduserform">
        <el-form-item label="人员名称：" label-width="120px">
          <el-input v-model="adduserform.username" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号码：" label-width="120px">
          <el-input v-model="adduserform.phonenum" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱：" label-width="120px">
          <el-input v-model="adduserform.mail" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="单位名称：" label-width="120px">
          <el-input v-model="adduserform.other" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="负责区域：" label-width="120px">
          <el-input v-model="adduserform.region" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="纬度：" label-width="120px">
          <el-input v-model="adduserform.lat" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="经度：" label-width="120px">
          <el-input v-model="adduserform.lon" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="12分钟预警：" label-width="120px">
          <!-- <el-input v-model="editData.ts12" autocomplete="off"></el-input> -->
          <el-switch v-model="adduserform.ts12"></el-switch>
        </el-form-item>
        <el-form-item label="30分钟预警：" label-width="120px">
          <!-- <el-input v-model="editData.ts30" autocomplete="off"></el-input> -->
          <el-switch v-model="adduserform.ts30"></el-switch>
        </el-form-item>
        <el-form-item label="60分钟预警：" label-width="120px">
          <!-- <el-input v-model="editData.ts60" autocomplete="off"></el-input> -->
          <el-switch v-model="adduserform.ts60"></el-switch>
        </el-form-item>
        <el-form-item label="自动推送：" label-width="120px">
          <!-- <el-input v-model="editData.ts60" autocomplete="off"></el-input> -->
          <el-switch v-model="adduserform.autosend"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowAddUserPop = false">取 消</el-button>
        <el-button type="primary" @click="addUserSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改信息" :visible.sync="isShowEditUserPop">
      <el-form :model="editData">
        <el-form-item label="人员名称：" label-width="120px">
          <el-input v-model="editData.username" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号码：" label-width="120px">
          <el-input v-model="editData.phonenum" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱：" label-width="120px">
          <el-input v-model="editData.mail" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="单位名称：" label-width="120px">
          <el-input v-model="editData.other" autocomplete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item label="职位名称：" label-width="120px">
          <el-input v-model="editData.re" autocomplete="off"></el-input>
        </el-form-item>-->
        <el-form-item label="负责区域：" label-width="120px">
          <el-input v-model="editData.region" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="经度：" label-width="120px">
          <el-input v-model="editData.lon" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="纬度：" label-width="120px">
          <el-input v-model="editData.lat" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="12分钟预警：" label-width="120px">
          <!-- <el-input v-model="editData.ts12" autocomplete="off"></el-input> -->
          <el-switch v-model="isSHowts12"></el-switch>
        </el-form-item>
        <el-form-item label="30分钟预警：" label-width="120px">
          <!-- <el-input v-model="editData.ts30" autocomplete="off"></el-input> -->
          <el-switch v-model="isSHowts30"></el-switch>
        </el-form-item>
        <el-form-item label="60分钟预警：" label-width="120px">
          <!-- <el-input v-model="editData.ts60" autocomplete="off"></el-input> -->
          <el-switch v-model="isSHowts60"></el-switch>
        </el-form-item>
        <el-form-item label="自动推送：" label-width="120px">
          <!-- <el-input v-model="editData.ts60" autocomplete="off"></el-input> -->
          <el-switch v-model="isOpenAtuoPush"></el-switch>
        </el-form-item>
        <!-- <el-form-item label="预报时效：" label-width="120px">
          <el-radio-group v-model="editData.time" size="small">
            <el-radio-button label="15分钟"></el-radio-button>
            <el-radio-button label="30分钟"></el-radio-button>
            <el-radio-button label="60分钟"></el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="预报距离：" label-width="120px">
          <el-radio-group v-model="editData.distance" size="small">
            <el-radio-button label="3公里"></el-radio-button>
            <el-radio-button label="6公里"></el-radio-button>
            <el-radio-button label="9公里"></el-radio-button>
          </el-radio-group>
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowEditUserPop = false">取 消</el-button>
        <el-button type="primary" @click="subMitEditData">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="人员选择" :visible.sync="isShowPeoPop" width="50%">
      <el-radio-group v-model="chooseUserData">
        <el-radio
          style="margin-top:10px"
          :label="item"
          v-for="item in userListData"
        >{{item.username}}--{{item.other}}</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowPeoPop = false">取 消</el-button>
        <el-button type="primary" @click="subSendataHanderll">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import { downloadXlsx } from "../../units/index";
import { MapCreate, legendColor } from "../map/mapImport";
import moment from "moment";
import shongjiangJson from "../map/310117-松江区";
import shongjiangstreeJson from "../map/310117.json";
import ligthing from "../assets/ligthing.png";
import litnew from "../assets/litnew.png";

export default {
  name: "set",
  data() {
    return {
      isSHowts12: false,
      isSHowts30: false,
      isSHowts60: false,
      isOpenAtuoPush: false,
      chooseUserData: [],
      meType: "",
      sendata: {},
      isShowPeoPop: false,
      adduserform: {
        username: "",
        phonenum: "",
        mail: "",
        lon: "",
        lat: "",
        region: "",
        other: "",
        ts12: 0,
        ts30: 0,
        ts60: 0
      },
      isShowEditUserPop: false,
      isShowAddUserPop: false,
      isShowWarningTable: true,
      markerLayer: null,
      chooseTabelData: {},
      isShoMyArea: false,
      startTime: "",
      endTime: "",
      value1: "",
      value2: "",
      chooseTime: "",
      tableData: [],
      waringleavelList: [
        {
          num: 0,
          color: "#409EFF",
          text: "无预警"
        },
        {
          num: 1,
          color: "#e6c700",
          text: "黄色"
        },
        {
          num: 2,
          color: "#e67b00",
          text: "橙色"
        },
        {
          num: 3,
          color: "#e62600",
          text: "红色"
        }
      ],
      userListData: [
        {
          name: "张三",
          tel: "18282789369",
          other: "test11",
          re: "管理员",
          state: "正常",
          creater: "root",
          createTime: "2024-07-08 12:00:00"
        }
      ],
      editData: {}
    };
  },
  created() {
    this.startTime = moment()
      .subtract(2, "d")
      .format("YYYYMMDD000000");
    // this.startTime = 20240604000000;
    this.endTime = moment().format("YYYYMMDDHH0000");
    // this.getData();
    // this.getUserData();
  },
  methods: {
    openUserChoosePop(type, data) {
      console.log(type, data);
      this.isShowPeoPop = true;
      this.meType = type;
      this.sendata = data;
    },
    subSendataHanderll() {
      // console.log(this.meType);
      // console.log(this.chooseUserData);
      // console.log(this.sendata);
      if (this.meType == "sendMsgData") {
        this.sendMsgData(this.sendata, this.chooseUserData);
      } else if (this.meType == "calluser") {
        this.calluser(this.sendata, this.chooseUserData);
      } else if (this.meType == "sendmail") {
        this.calluser(this.sendata, this.chooseUserData);
      }
    },
    sendMsgData(data, user) {
      //推送短信
      console.log(data, user);
      //   return;
      let color = this.getText(data.level);
      // console.log(color);
      let formData = new FormData();

      formData.append(
        "params",
        `{"phones":"${user.phonenum}","sendcontent":"未来${data.Timeliness}分钟发生雷电${color}预警"}`
      );
      this.$axios({
        method: "post",

        url: `http://10.228.202.140:3099/SendMessage/sendNote`,
        data: formData
      }).then(res => {
        // console.log(res);
      });
    },
    calluser(data, user) {
      //呼叫
      // console.log(data);
      let color = this.getText(data.level);
      let formData = new FormData();

      formData.append(
        "params",
        `{"phones":"${user.phonenum}","sendcontent":"未来${data.Timeliness}分钟发生雷电${color}预警"}`
      );
      this.$axios({
        method: "post",

        url: `http://10.228.202.140:3099/SendMessage/sendSingleCall`,
        data: formData
      }).then(res => {
        // console.log(res);
      });
    },
    sendmail(data, user) {
      //邮件
      let color = this.getText(data.level);
      let formData = new FormData();

      formData.append(
        "params",
        `{"recipient":"${user.mail}","sendcontent":"未来${data.Timeliness}分钟发生雷电${color}预警"}`
      );
      this.$axios({
        method: "post",

        url: `http://10.228.202.140:3099/MailMonitor/sendMail`,
        data: formData
      }).then(res => {
        // console.log(res);
      });
    },
    showEditpopHandell(data) {
      this.editData = data;
      console.log(data.ts12);
      this.isSHowts12 = !!data.ts12;
      this.isSHowts30 = !!data.ts30;
      this.isSHowts60 = !!data.ts60;
      this.isOpenAtuoPush = !!data.autosend;
      console.log(!!data.ts12, !!data.ts30, !!data.ts60);
      this.isShowEditUserPop = true;
    },
    subMitEditData() {
      // console.log(this.editData);
      let formData = new FormData();

      formData.append(
        "params",
        `{"Data":[{"thisid":"${this.editData.id}","username":"${
          this.editData.username
        }","phonenum":"${this.editData.phonenum}","mail":"${
          this.editData.mail
        }","lon":"${this.editData.lon}","lat":"${
          this.editData.lat
        }","region":"${this.editData.region}","other":"${
          this.editData.other
        }","ts12":"${Number(this.isSHowts12)}","ts30":"${Number(
          this.isSHowts30
        )}","ts60":"${Number(this.isSHowts60)}","autosend":"${Number(
          this.isOpenAtuoPush
        )}"}]}`
      );
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // url: `http://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getLdWarninfoBytimes&starttime=20230617000000&endtime=20230618110000`
        url: `http://10.228.202.140:8080/SWDataservice/Thuder/updateTDUserList`,
        data: formData
      }).then(res => {
        console.log(res);
        this.isShowEditUserPop = false;
        this.getUserData();
        // this.userListData = res.data.dataList;
      });
    },
    delUserData(data) {
      // console.log(data);
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // url: `http://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getLdWarninfoBytimes&starttime=20230617000000&endtime=20230618110000`
        url: `${this.$url}?interfaceId=deleteLdUserlist&thisid=${data.id}`
      }).then(res => {
        // console.log(res);
        // this.isShowAddUserPop = false;
        this.getUserData();
        // this.userListData = res.data.dataList;
      });
    },
    addUserSubmit() {
      let formData = new FormData();

      formData.append(
        "params",
        `{"Data":[{"username":"${this.adduserform.username}","phonenum":"${
          this.adduserform.phonenum
        }","mail":"${this.adduserform.mail}","lon":"${
          this.adduserform.lon
        }","lat":"${this.adduserform.lat}","region":"${
          this.adduserform.region
        }","other":"${this.adduserform.other}","ts12":"${Number(
          this.adduserform.ts12
        )}","ts30":"${Number(this.adduserform.ts30)}","ts60":"${Number(
          this.adduserform.ts60
        )}","autosend":"${Number(this.adduserform.autosend)}"}]}`
      );
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // url: `http://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getLdWarninfoBytimes&starttime=20230617000000&endtime=20230618110000`
        url: `http://10.228.202.140:8080/SWDataservice/Thuder/insertTDUserList`,
        data: formData
      }).then(res => {
        console.log(res);
        this.isShowAddUserPop = false;
        this.getUserData();
        // this.userListData = res.data.dataList;
      });
    },
    getUserData() {
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // url: `http://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getLdWarninfoBytimes&starttime=20230617000000&endtime=20230618110000`
        url: `${this.$url}?interfaceId=getLdUserlist`
      }).then(res => {
        // console.log(res.data.dataList);
        this.userListData = res.data.dataList;
        this.chooseUserData = res.data.dataList[0];
      });
    },
    openUserTable() {
      this.isShowWarningTable = !this.isShowWarningTable;
    },
    downTable() {
      let datalist = []; // 需要导出的表格数据
      datalist.push([
        "起报时间",
        "预测经度",
        "预测纬度",
        "预警级别(3km)",
        "预警级别(6km)",
        "预警级别(9km)",
        "预测时效"
      ]);

      // this.list 获取后台接口数据
      this.tableData.forEach((item, index) => {
        // 拼接excel表格数据
        datalist.push([
          item.dTime,
          item.lon,
          item.lat,
          this.getText(item.level),
          this.getText(item.level12),
          this.getText(item.level18),
          item.Timeliness
        ]);
      });
      //   downloadXlsx(
      //     datalist,
      //     `${this.startTime}至${this.endTime}雷电预警表.xlsx`
      //   );
    },
    getTimeStr(data) {
      // scope.row.dTime
      return moment(data, "YYYYMMDDHHmmss").format("YYYY-MM-DD HH:mm:ss");
    },
    openPophandell() {
      this.map = new MapCreate();
      this.map.init("newMapBox2");
      let t = this;
      let mymakerList2 = [];
      const style2 = {
        color: "#01203f", //线颜色
        weight: 2, //线粗细
        opacity: 1, //透明度
        fillColor: "#fff", //区域填充颜色
        fillOpacity: 0 //区域填充颜色的透明
      };
      this.streetLayer = L.geoJSON(shongjiangstreeJson.features, {
        style: style2
      }).addTo(this.map.map);
      // this.streetNameLayer = L.layerGroup(mymakerList2).addTo(this.map.map);

      const style = {
        color: "red", //线颜色
        weight: 4, //线粗细
        opacity: 1, //透明度
        fillColor: "#fff", //区域填充颜色
        fillOpacity: 0 //区域填充颜色的透明
      };
      this.areaLayer = L.geoJSON(shongjiangJson.features, {
        style: style
      }).addTo(this.map.map);
      this.map.map.fitBounds(this.areaLayer.getBounds());
      let greenIcon = L.icon({
        iconUrl: ligthing,
        iconSize: [30, 30] // size of the icon
      });
      let mymakerList = [];
      mymakerList.push(
        L.circle([this.chooseTabelData.lat, this.chooseTabelData.lon], {
          radius: 3000,
          color: this.getColor(this.chooseTabelData.level),
          fillOpacity: 0
        })
      );
      mymakerList.push(
        L.circle([this.chooseTabelData.lat, this.chooseTabelData.lon], {
          radius: 6000,
          color: this.getColor(this.chooseTabelData.level12),
          fillOpacity: 0
        })
      );
      mymakerList.push(
        L.circle([this.chooseTabelData.lat, this.chooseTabelData.lon], {
          radius: 9000,
          color: this.getColor(this.chooseTabelData.level18),
          fillOpacity: 0
        })
      );
      mymakerList.push(
        L.marker([this.chooseTabelData.lat, this.chooseTabelData.lon], {
          icon: greenIcon
        }).bindPopup(`
            <p>起报时间：${this.getTimeStr(this.chooseTabelData.dTime)}</p>
            <p>预测经度：${this.chooseTabelData.lon}</p>
            <p>预测纬度：${this.chooseTabelData.lat}</p>
            <p>预警级别(3km)：${this.getText(this.chooseTabelData.level)}</p>
            <p>预警级别(6km)：${this.getText(this.chooseTabelData.level12)}</p>
            <p>预警级别(9km)：${this.getText(this.chooseTabelData.level18)}</p>
            <p>预测时效：${this.chooseTabelData.Timeliness}min</p>
            `)
      );
      this.markerLayer = L.layerGroup(mymakerList)
        .addTo(this.map.map)
        .setZIndex(10);
    },
    closeHandell() {
      this.map.map.remove();
    },
    showMap(data) {
      console.log(data);
      this.isShoMyArea = true;
      this.chooseTabelData = data;
    },
    getColor(data) {
      if (data == null) {
        return "";
      } else {
        let waringleavelList = this.waringleavelList;
        let myLeavel = waringleavelList.filter(el => {
          return el.num == data;
        });
        // console.log(myLeavel);
        return myLeavel[0].color;
      }
    },
    getText(data) {
      if (data == null) {
        return "";
      } else {
        let waringleavelList = this.waringleavelList;
        let myLeavel = waringleavelList.filter(el => {
          return el.num == data;
        });
        // console.log(myLeavel);
        return myLeavel[0].text;
      }
    },
    retuTime() {
      this.startTime = moment()
        .subtract(2, "d")
        .format("YYYYMMDD000000");
      this.endTime = moment().format("YYYYMMDDHH0000");
      this.getData();
    },
    getData() {
      // console.log(22222);
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // url: `http://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getLdWarninfoBytimes&starttime=20230617000000&endtime=20230618110000`
        url: `${this.$url}?interfaceId=getLdWarninfoBytimes&starttime=${this.startTime}&endtime=${this.endTime}`
      })
        .then(res => {
          // console.log(res);
          // this.tableData=res.data.dataList
          // let waringleavelList = this.waringleavelList;
          // res.data.dataList.map(item => {
          //   let myLeavel = waringleavelList.filter(el => {
          //     return el.num == item.level;
          //   });
          //   // console.log(myLeavel[0]);
          //   item.text = myLeavel[0].text;
          //   item.color = myLeavel[0].color;
          //   item.dTime = moment(item.dTime, "YYYYMMDDHHmmss").format(
          //     "YYYY-MM-DD HH:mm:ss"
          //   );
          //   return item;
          // });
          this.tableData = res.data.dataList;
          loading.close();

          // console.log( this.tableData);
        })
        .catch(err => {
          loading.close();
        });
    }
  }
};
</script>

<style>
.conBody {
  width: 100%;
  /* height: 100%; */
  min-height: calc(100vh - 84px);
  padding: 15px;
  /* background-color: red; */
}
.tableHeaderBox {
  height: 50px;
  width: 100%;
  /* background-color: aqua; */
  display: flex;
  align-items: center;
}
</style>